module.exports = __webpack_public_path__ + "img/b614517.png";